import React, { useState,useRef,useEffect,useCallback } from "react";
import mainBanner from "../images/new/creator/main-banner.jpg";
import Background from "../components/Banner/Background";
import { bannerBackgrounds,bannerAvatars,assetStickers,fontFamilies,fontWeights } from "../const/const";
import BannerTraits from "../components/Banner/BannerTraits";
import BannerBackgrounds from "../components/Banner/BannerBackgrounds";
import BannerAvatars from "../components/Banner/BannerAvatars";
import Customize from "../components/Banner/Customize";
import html2canvas from "html2canvas";
const avatarChecks = ["Male","Female"]
function CreateBanner() {
  function generateUniqueKey() {
    let array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return array[0].toString(16);
  }
  const [selectedCategory, setSelectedCategory] = useState(
    Object.keys(assetStickers.Male)[0]
  );
  const [selectedStickerPack, setSelectedStickerPack] = useState([]);
  const parentRef = useRef(null);
  const memeDivRef = useRef(null);
  const [parentWidthHeight, setParentWidthHeight] = useState();
  const [text, setText] = useState({});
  const [selectedAssets, setSelectedAssets] = useState({});
  const [download, setDownload] = useState(false);
  const [templateObjectUrl, setTemplateObjectUrl] = useState(null);
  const [latestImageSelected, setLatestImageSelected] = useState(null);

  const [state, setState] = useState([
    {
      text: {
        0: {
          text: "",
          fontFamily: fontFamilies[0],
          fontWeight: fontWeights[0],
          id: 0,
          fill: "#FFFFFF",
          align: "left",
          stroke: "black",
        },
        1: {
          text: "",
          fontFamily: fontFamilies[0],
          fontWeight: fontWeights[0],
          id: 1,
          fill: "#FFFFFF",
          align: "left",
          stroke: "black",
        },
      },
      selectedAssets: {},
    },
  ]);
  const [redo, setRedo] = useState([]);
  const [selectedId, selectShape] = useState(null);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [selectedBanner,setSelectedBanner]  = useState(mainBanner)
  const [selectedAvatarCategory,setSelectedAvatarCategory] = useState("Male")
  const checkDeselect = (e) => {
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      selectShape(null);
    }
  };
  useEffect(() => {
    //loadImage();
  }, []);
  useEffect(() => {
    document.addEventListener("click", function (event) {
      const contentArea = document.getElementById("Meme");
      const contentArea2 = document.getElementById("customize");
      console.log(contentArea);
      if (
        !contentArea.contains(event.target) &&
        !contentArea2.contains(event.target)
      )
        selectShape(null);
    });
  }, [selectedId]);
  // const loadImage = async () => {
  //   try {
  //     const response = await fetch(selectedTemplate, {
  //       headers: { "Cache-Control": "no-cache" },
  //     });
  //     const blob = await response.blob();
  //     const dataUrl = URL.createObjectURL(blob);
  //     const img = new Image();
  //     img.src = dataUrl;
  //     setTemplateObjectUrl(dataUrl);
  //     if (img.complete) {
  //       setParentWidthHeight({
  //         parentHeight: img.height > 380 ? 380 : img.height,
  //         parentWidth:
  //           img.height > 380 ? (img.width * 380) / img.height : img.width,
  //       });
  //     } else {
  //       img.onload = () => {
  //         setParentWidthHeight({
  //           parentHeight: img.height > 380 ? 380 : img.height,
  //           parentWidth:
  //             img.height > 380 ? (img.width * 380) / img.height : img.width,
  //         });
  //       };
  //     }
  //   } catch (error) {
  //     console.error("Error loading image:", error);
  //   }
  // };
  useEffect(() => {
    if (latestImageSelected) {
      const key = generateUniqueKey();
      const currentState = state[state.length - 1];
      const temp = {
        ...currentState.selectedAssets,
        [key]: { id: key, url: latestImageSelected, width: 100, height: 100 },
      };
      setState([
        ...state,
        { selectedAssets: { ...temp }, text: { ...currentState.text } },
      ]);
      setRedo([]);
      setLatestImageSelected(null);
    }
  }, [latestImageSelected]);
  useEffect(() => {
    if (download && selectedId) selectShape(null);
    else if (download) handleDownload();
  }, [download]);
  useEffect(() => {
    if (!selectedId && download)
      setTimeout(() => {
        handleDownload();
      }, 100);
  }, [selectedId]);
  useEffect(() => {
    const handleDeleteKeyPress = (event) => {
      console.log(event.keyCode);
      // Check if the user is on Windows
      if (navigator.userAgent.indexOf("Win") !== -1) {
        if (
          (event.key === "Delete" || event.keyCode === 46) &&
          selectedId != null
        ) {
          deleteAsset();
        }
      }

      // Check if the user is on Mac
      if (navigator.userAgent.indexOf("Mac") !== -1) {
        if (
          (event.key === "Delete" || event.keyCode === 8) &&
          selectedId != null
        ) {
          console.log(event.key);
          deleteAsset();
        }
      }
    };
    document.addEventListener("keydown", handleDeleteKeyPress);
    return () => {
      document.removeEventListener("keydown", handleDeleteKeyPress);
    };
  }, [selectedId]);
  useEffect(() => {
    if (selectedCategory) {
      const BASE_URL =
        "https://hh-devserver-bucket.s3.us-east-2.amazonaws.com/Assets/Images/Meme-Generator-Assets/";
      setSelectedStickerPack([
        ...assetStickers.Male[selectedCategory].map((val, index) => {
          return {
            image: BASE_URL + "Male/" + selectedCategory + "/" + val,
            id: generateUniqueKey(),
            name: selectedCategory + `${index + 1}`,
          };
        }),
      ]);
    }
  }, [selectedCategory]);
  useEffect(() => {
    const currentState = state[state.length - 1];
    setSelectedAssets({ ...currentState.selectedAssets });
    setText({ ...currentState.text });
  }, [state]);
  useEffect(()=>{
    if(downloadLoader){
      const element = document.getElementById('root')
      element.className = 'root fade'
      window.scrollTo({top:0})
    }
    else{
      const element = document.getElementById('root')
      element.className = ''
    }
  },[downloadLoader])
  const changeText = (id, key, value) => {
    const currentState = state[state.length - 1];
    const temp = {
      ...currentState.text,
      [id]: { ...currentState.text[id], [key]: value },
    };
    setState([
      ...state,
      { text: { ...temp }, selectedAssets: { ...currentState.selectedAssets } },
    ]);
    setRedo([]);
  };
  
  const addAssets = useCallback((asset) => {
    setLatestImageSelected(asset.image);
  }, []);
  const deleteAsset = () => {
    const currentState = state[state.length - 1];
    const temp = { ...currentState.selectedAssets };
    const temp2 = { ...currentState.text };
    delete temp[selectedId];
    if (temp2[selectedId]) {
      temp2[selectedId].text = "";
    }
    setState([...state, { selectedAssets: { ...temp }, text: { ...temp2 } }]);
    selectShape(null);
  };
  const changeAsset = (key, newAsset) => {
    const currentState = state[state.length - 1];
    const temp = { ...currentState.selectedAssets, [key]: { ...newAsset } };
    setState([
      ...state,
      { selectedAssets: { ...temp }, text: { ...currentState.text } },
    ]);
    setRedo([]);
  };
  const changeEntireText = (key, newText) => {
    const currentState = state[state.length - 1];
    const temp = { ...currentState.text, [key]: { ...newText } };
    setState([
      ...state,
      { selectedAssets: currentState.selectedAssets, text: { ...temp } },
    ]);
    setRedo([]);
  };
  const handleDownload = async () => {
    try {
      html2canvas(memeDivRef.current, {
        useCORS: true,
        allowTaint: true,
        imageTimeout: 0,
        onclone: (clonedDoc) => {
          clonedDoc.getElementById('profile-pic-bubble').style.display = 'none'
          clonedDoc.getElementById("background").style.borderRadius = "0px"
        },
      }).then((canvas) => {
        const dataURL = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.download = "banner.png";
        link.href = dataURL;
        link.click();
        setDownloadLoader(false);
        setDownload(false);
      });
      setTimeout(() => {
        setDownloadLoader(true);
      }, 5);
    } catch (error) {
      console.error("Error while capturing element as image:", error);
    }
  };
  
  
  return (
    <div className="creator-section">
      <div className="creation-block">
      {downloadLoader ? <div className="loader"></div> :<></>}
        <Background 
          ref = {memeDivRef}
          selectedBanner={selectedBanner}
          changeAsset={changeAsset}
          changeEntireText={changeEntireText}
          selectShape={selectShape}
          selectedAssets={selectedAssets}
          selectedId={selectedId}
          text={text}
        />
        <div className="flexer">
          <div className="left-column">
            <BannerBackgrounds bannerBackgrounds={bannerBackgrounds} selectBanner={(bg)=>setSelectedBanner(bg)}/>
            <BannerTraits 
              addAssets={addAssets}
              assetStickers={assetStickers}
              selectedCategory={selectedCategory}
              selectedStickerPack={selectedStickerPack}
              setSelectedCategory={setSelectedCategory}
            />
            <BannerAvatars 
             addAssets={addAssets}
             bannerAvatars={bannerAvatars}
             avatarChecks={avatarChecks}
             selectedAvatarCategory={selectedAvatarCategory}
             setSelectedAvatarCategory={setSelectedAvatarCategory}
            />
          </div>
          <div className="right-column">
              <Customize
              changeEntireText={changeEntireText}
              changeText={changeText}
              fontFamilies={fontFamilies}
              fontWeights={fontWeights}
              generateUniqueKey={generateUniqueKey}
              handleClose={()=>{}}
              setState={setState}
              state={state}
              text={text}
              />
            </div>
        </div>
        <div className="actions">
          
          <button className="solid-button primary" onClick={()=>setDownload(true)}>Download</button>
        </div>
      </div>
    </div>
  );
}

export default CreateBanner;
